import React, { memo, useState, useEffect } from "react";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import Dashboard from "../../../Dashbard";
import AddIcon from "@material-ui/icons/Add";
import FAQuesGrid from "./FAQuesGrid";

import {
    SupportTabButtons,
} from "../../../../../../components/common";
import Loader from "../../../../../../components/common/Loader";
import { FAQDataView } from "../FAQuesDataView";

const AllFAQues = ({ activeTabSection = 0 }) => {
  document.title = "OFish - Support FAQs";

  const history = useHistory();

  const [activeTabId, setActiveTabId] = useState(`${activeTabSection}`);

  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setActiveTabId(`${activeTabSection}`);
  }, [activeTabSection]);

  const RenderSection = memo(() => {
    switch (`${activeTabSection}`) {
      case "0":
        return <FAQDataView />;
    //   case "1":
    //     return <CompaniesDataView />;
    //   case "2":
    //     return (
    //       <BusinessGroup
    //         isNewBusinessGroup={isNewBusinessGroup}
    //         setIsNewBusinessGroup={setIsNewBusinessGroup}
    //       />
    //     );
    //   case "3":
    //     return <FavBusinessContactDataView />;
    //   case "4":
    //     return <FavBusinessContactDataView isRecentlyAdded />;
    //   case "5":
    //     return <BusinessContactDataView isArchived={true} />;
    //   case "6":
    //     return <BusinessContactDataView isBlocked={true} />;
    //   case "7":
    //     return <BusinessContactDataView isDeleted={true} />;
    //   case "8":
    //     return <BlockedLocationGrid />;

      default:
        return <h1>No Support Page Found!</h1>;
    }
  });

  return (
    <Dashboard>
      <div className='body-content'>
        {isLoading ? <Loader /> : null}
        <div className='contentHeading'>
          <h1>FAQs </h1>
            <Button
              color='primary'
              onClick={() => {
                history.push("/new-faq");
              }}
              startIcon={<AddIcon />}
              variant='contained'>
              Add New Question
            </Button>
        </div>
        <SupportTabButtons />
        <RenderSection />
      </div>
    </Dashboard>
  );
};

export { AllFAQues };
